var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPaymentInBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM8,15.3A7.3,7.3,0,1,1,15.3,8,7.3,7.3,0,0,1,8,15.3Z",
    fill: "#1d2650"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M9,12.08H7a.29.29,0,0,1-.3-.3V9.39c0-.57.3-.61.39-.61H8.91c.09,0,.39,0,.39.61v2.39a.29.29,0,0,1-.3.3Zm-1.7-.6H8.7V9.39H7.3Z",
    fill: "#1d2650"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M11.38,9.38a.3.3,0,0,1-.3-.3V7.4a.3.3,0,0,1,.3-.3.29.29,0,0,1,.3.3V9.08a.29.29,0,0,1-.3.3Z",
    fill: "#1d2650"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M4.62,9.38a.29.29,0,0,1-.3-.3V7.4a.29.29,0,0,1,.3-.3.3.3,0,0,1,.3.3V9.08A.3.3,0,0,1,4.62,9.38Z",
    fill: "#1d2650"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M11.08,12.08H4.92c-.34,0-.6-.35-.6-.81V9a.3.3,0,0,1,.3-.3.31.31,0,0,1,.3.3v2.31A.37.37,0,0,0,5,11.5h6.1V9a.31.31,0,0,1,.3-.3.3.3,0,0,1,.3.3v2.31A.727.727,0,0,1,11.08,12.08Z",
    fill: "#1d2650"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M9,7.62a1.3,1.3,0,0,1-1.3-1.3.3.3,0,1,1,.6,0A.7.7,0,0,0,9,7a.71.71,0,0,0,.71-.7.3.3,0,0,1,.6,0A1.31,1.31,0,0,1,9,7.62Z",
    fill: "#1d2650"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M7,7.62a1.3,1.3,0,0,1-1.29-1.3.3.3,0,0,1,.6,0A.69.69,0,0,0,7,7a.7.7,0,0,0,.7-.7.3.3,0,1,1,.6,0A1.3,1.3,0,0,1,7,7.62Z",
    fill: "#1d2650"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M11,7.62a1.3,1.3,0,0,1-1.29-1.3.3.3,0,0,1,.6,0A.69.69,0,0,0,11,7a.7.7,0,0,0,.7-.7V4.53H4.31v1.8A.7.7,0,0,0,5,7a.71.71,0,0,0,.71-.7.3.3,0,0,1,.6,0,1.31,1.31,0,0,1-2.61,0V4.53a.61.61,0,0,1,.61-.61h7.38a.61.61,0,0,1,.61.61V6.32A1.3,1.3,0,0,1,11,7.62Z",
    fill: "#1d2650"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentInBusiness);
export default __webpack_public_path__ + "static/media/IconPaymentInBusiness.cdfb4e4a.svg";
export { ForwardRef as ReactComponent };